import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_ScrollBar = _resolveComponent("ScrollBar")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    min_width: "48rem",
    centered: false,
    onClickOutside: $options.close
  }, {
    header: _withCtx(() => [
      _createTextVNode(_toDisplayString($options.editing ? 'Edit output field' : 'Add output field'), 1 /* TEXT */)
    ]),
    content: _withCtx(() => [
      _createVNode(_component_ScrollBar, {
        class: "output-form",
        "bar-x-offset": "-0.5rem"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_BuilderInputs, {
            ref: "fields",
            "vread-from": "valid",
            "onUpdate:valid": $event => (($data.valid) = $event),
            opts: $data.schema,
            propstore: $data.fields,
            gap: "1.6rem"
          }, null, 8 /* PROPS */, ["onUpdate:valid", "opts", "propstore"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, { onClick: $options.close }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Cancel")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"]),
      _createVNode(_component_Button, {
        primary: "",
        disabled: !$options.can_save,
        onClick: $options.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.editing ? 'Save' : 'Add field'), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled", "onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["onClickOutside"]))
}